// extracted by css-extract-rspack-plugin
export default {"icons":"SocialLinks-module__icons--FUhk6","icon":"SocialLinks-module__icon--pyBOs"};